import { useMemo } from 'react';
import OnboardingTour from 'onboarding-tours/components/OnboardingTour';
import { shouldRenderTour } from 'onboarding-tours/util/activeTour';
import { useLocation } from 'react-router-dom';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import ErrorBoundary from '../errorBoundary/ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function IndexPageAlerts() {
  const location = useLocation();
  const tourIdSearchParam = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    const tourId = searchParams.get('tourId');
    return tourId !== null && tourId !== void 0 ? tourId : undefined;
  }, [location.search]);
  const shouldShowOnboardingTourComponent = shouldRenderTour();
  const onboardingTour = useMemo(() => {
    if (shouldShowOnboardingTourComponent) {
      return /*#__PURE__*/_jsx(ErrorBoundary, {
        boundaryName: "OnboardingTour",
        showAlertToUser: false,
        children: /*#__PURE__*/_jsx(OnboardingTour, {
          tourId: tourIdSearchParam
        })
      });
    }
    return null;
  }, [shouldShowOnboardingTourComponent, tourIdSearchParam]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FloatingAlertList, {
      "data-test-id": "IndexPageAlerts"
    }), onboardingTour]
  });
}
export default IndexPageAlerts;